module.exports = __webpack_public_path__ + "static/media/YFI-BNB.d49a85b5.svg";